// Keeps an open tab on the deployed version (Oct 11 2026). A phone that keeps Valor Web open in a tab keeps running the
// JavaScript and CSS it loaded, while unversioned art (the slate textures) is fetched fresh — after a deploy that tab showed
// the old layout over the new materials. The Worker reports its deployed version at /api/health; when the player comes
// back to the tab and that version has changed, the page reloads once (only on returning to the tab, never mid-tap).
let loaded: string | null = null;
let checking = false;

const current = async (): Promise<string | null> => {
  try {
    const r = await fetch("/api/health", { cache: "no-store" });
    if (!r.ok) return null;
    const j = (await r.json()) as { version?: string };
    return typeof j.version === "string" ? j.version : null;
  } catch {
    return null;
  }
};

async function check() {
  if (checking) return;
  checking = true;
  try {
    const v = await current();
    if (!v || v === "dev") return;
    if (loaded === null) loaded = v;
    else if (v !== loaded) window.location.reload();
  } finally {
    checking = false;
  }
}

if (typeof window !== "undefined" && typeof document !== "undefined") {
  void check();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void check();
  });
  window.addEventListener("pageshow", (e) => {
    if ((e as PageTransitionEvent).persisted) void check(); // restored from the back/forward cache
  });
}
